module.exports = __webpack_public_path__ + "img/Philippines.bcf91461.jpg";